import { createAudioServices } from "@/features/audio/services/audio-services.factory";
import { createTelephonyProvider } from "@/features/telephony/adapters/providers/telephony-provider.factory";
import { CallManager } from "@/features/telephony/services/call-manager.service";
import { TelephonyEventBus } from "@/features/telephony/services/telephony-event-bus";
import { TelephonyStateStore } from "@/features/telephony/services/telephony-state.store";
import { CreateTelephonyServicesOptions } from "@/features/telephony/types/telephony-config.types";

export const createTelephonyServices = (options?: CreateTelephonyServicesOptions) => {
    const provider = createTelephonyProvider(options?.providerId);
    const audio = createAudioServices();
    const telephonyStateStore = new TelephonyStateStore();
    const telephonyEventBus = new TelephonyEventBus();
    const callManager = new CallManager(provider, telephonyEventBus, telephonyStateStore);

    audio.deviceManager.setDeviceRouter({
        setInputDevice: (deviceId) => provider.setInputDevice(deviceId),
        setOutputDevice: (deviceId) => provider.setOutputDevice(deviceId),
    });

    return {
        callManager,
        deviceManager: audio.deviceManager,
        permissionManager: audio.permissionManager,
        eventBus: telephonyEventBus,
        telephonyStateStore,
        audioStateStore: audio.stateStore,
        provider,
    };
};

export type TelephonyServices = ReturnType<typeof createTelephonyServices>;

export const telephonyServices = createTelephonyServices();

export const callManager = telephonyServices.callManager;
export const deviceManager = telephonyServices.deviceManager;
export const permissionManager = telephonyServices.permissionManager;
export const audioStateStore = telephonyServices.audioStateStore;

export const switchTelephonyProvider = (
    providerId: NonNullable<CreateTelephonyServicesOptions["providerId"]>
): TelephonyServices => {
    return createTelephonyServices({ providerId });
};
